import { getPath } from '@/router/common'

const baseUrl = {
  title: '系统锁定中，需要密码才能打开',
  path: 'LeaveState'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'LeaveState_Index',
    component: () => import(/* webpackChunkName: "LeaveState_Index" */ '@/views/leaveState/index/index.vue'),
    meta: {
      title: '系统锁定中，需要密码才能打开'
    }
  }
]
